import { lazy } from "react";

import { ReporteriaLayout } from "../layouts/ReporteriaLayout";
import RutaProtegida from "@components/RutaProtegida";
import { BajoConstruccion } from "@components/BajoConstruccion";

const Solicitudes = lazy(() => import("../components/sections/Solicitudes"));

export const reporteriaRoutes = {
    element: <RutaProtegida permissionCodes={["MREPORT"]} />,
    children: [
        {
            Component: ReporteriaLayout,
            path: "/reporteria",
            children: [
                {
                    Component: Solicitudes,
                    path: "solicitudes",
                },
                {
                    Component: BajoConstruccion,
                    path: "reconsideraciones",
                },
            ],
        },
    ],
};
